import { supabase } from "../supabaseClient";

/**
 * Delete a single user item by ID using the delete_item_with_cleanup RPC.
 * @param {string | number} id - The user_item ID to delete.
 */
export const deleteItem = async (id) => {
  if (!id) {
    console.error("deleteItem called without id");
    return;
  }

  try {
    const { data, error } = await supabase.rpc("delete_item_with_cleanup", {
      p_item_id: id,
   });


    if (error) throw error;
    return data;
  } catch (err) {
    console.error("Failed to delete item:", err);
    throw err;
  }
};
